import './Service.scss';
import React, { FC } from 'react';
import SafeLink from '@/components/extra/SafeLink/SafeLink';
import { useFoyerConfig, useFoyerConfigDispatch } from '../FoyerProvider';
import UserCurrent from '@/components/user/UserCurrent/UserCurrent';
import ButtonIcon from '@/components/basic/ButtonIcon/ButtonIcon';
import type { IconType } from '@/components/extra/Icon/Icon';
import { serviceItems } from '@/components/page/page-registry';

type ServiceProps = Record<string, never>;

const Service: FC<ServiceProps> = () => {
    const foyerConfig = useFoyerConfig();
    const foyerConfigDispatch = useFoyerConfigDispatch();

    const setActiveServiceServiceMenu = (serviceMenu = null) => {
        foyerConfigDispatch({
            type: 'SET_ACTIVE_SERVICE_MENU',
            serviceMenu: serviceMenu,
        });
    };

    const closeServiceMenu = () => {
        foyerConfigDispatch({
            type: 'TOGGLE_SERVICE',
        });
    };

    return (
        <>
            <section className="Service_header">
                <ButtonIcon
                    icon="back"
                    label="zurück"
                    disabled={!foyerConfig.activeServiceMenu}
                    onClick={setActiveServiceServiceMenu}
                />
                <h2 className="Service_headerTitle">
                    {foyerConfig.activeServiceMenu
                        ? foyerConfig.activeServiceMenuTitle
                        : 'Extras & Services'}
                </h2>
            </section>
            <section className="Service_list">
                {serviceItems.map((item) => (
                    <section
                        key={item.path}
                        className={`Service_item ${item.path}`}
                    >
                        <SafeLink
                            to={item.path}
                            className="Service_link"
                            onClick={closeServiceMenu}
                        >
                            <ButtonIcon
                                className="Service_icon"
                                icon={item.icon as IconType}
                            />
                            <h2 className="Service_title">{item.title}</h2>
                        </SafeLink>
                        <SafeLink
                            to={item.path}
                            className="Service_next"
                            onClick={closeServiceMenu}
                        >
                            <ButtonIcon
                                icon="chevron"
                                label={`${item.title} auswählen`}
                            />
                        </SafeLink>
                    </section>
                ))}
                <UserCurrent />
            </section>
        </>
    );
};

export default Service;
